import AutoGrowTextarea from '../AutoGrowTextarea';

export default function TextNode({ id, data }) {
    return (
        <AutoGrowTextarea
            minRows={3}
            className="spt-textarea border-2"
            placeholder="Digite o texto da mensagem"
            value={data?.text || ''}
            onChange={(e) => data?.onChangeText?.(id, e.target.value)}
        />
    );
}
